module.exports = __webpack_public_path__ + "img/Hunter-bloodelf-m-70.40ffa4fd.gif";